module.exports = "/_next/static/images/Burger-icon-0714d910f31789da46d15b2e34ae5c32.svg";